/* global */
import React from 'react';
import PropTypes from 'prop-types';

function Card({
  children,
  highlighted,
  blue,
  green,
  raised,
  muted,
  error,
  className,
  name = null,
}) {
  return (
    <div
      className={`
      uds-card
      ${highlighted ? 'uds-card--highlighted' : ''}
      ${raised ? 'uds-card--raised' : ''}
      ${blue ? 'uds-card--blue' : ''}
      ${green ? 'uds-card--green' : ''}
      ${muted ? 'uds-card--muted' : ''}
      ${error ? 'uds-card--error' : ''}
      ${className}
    `}
      data-name={name}
      data-cy="promotionCard"
    >
      {children}
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node,
  highlighted: PropTypes.bool,
  blue: PropTypes.bool,
  green: PropTypes.bool,
  error: PropTypes.bool,
  raised: PropTypes.bool,
  muted: PropTypes.bool,
  className: PropTypes.string,
};

export function CardPanel({ children, green, className = '' }) {
  return (
    <div
      className={`uds-card__panel ${
        green ? 'uds-card__panel--green' : ''
      } ${className}`}
    >
      {children}
    </div>
  );
}

CardPanel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  green: PropTypes.bool,
};

export default Card;
